import { Line } from 'vue-chartjs'

export default {
  extends: Line,
  watch:{
    rerender(){
      this.renderChart(this.chartdata, this.options)
    }
  },
  props: {
    chartdata: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    },
    rerender:{
      default:false
    }
  },
  mounted () {
    this.renderChart(this.chartdata, this.options)
    this.$refs.canvas.height = '250px'
  }
}